import systemApi from "api/systemApi";

export const postUploadFileMulti = async (data: any = {}) => {
  try {
    const response = await systemApi.postUploadFileMulti(data);
    return response;
  } catch (error) {
    return error;
  }
};